import React from 'react';
import {
  TextOption,
  SMSWhatsapp,
  Info,
  IconSMS,
  Options,
  IconWhatsapp,
  SMSOption,
  Section,
  WhatsAppOption,
  SelectWhatsapp,
  SelectSMS,
} from './styles';

interface Contact {
  info: string;
  typeContact: GQL.ITelephone;
  selectFunction: (type: 'sms' | 'whatsapp', contact?: UserContact) => void;
  onkeypress: Function;
  handleGenerateToken: Function;
  isSelected: boolean;
  type?: 'email' | 'sms' | 'whatsapp';
}

const TelephoneCard: React.FC<Contact> = ({
  info,
  selectFunction,
  typeContact,
  onkeypress,
  isSelected,
  type,
}) => {
  return (
    <SMSWhatsapp
      tabIndex={0}
      className={isSelected ? 'selected' : ''}
      onKeyPress={(e) => onkeypress(e)}
    >
      <Info>{info}</Info>
      <Options>
        <Section
          onClick={() => selectFunction('whatsapp', typeContact)}
          className='wpp-section'
        >
          <WhatsAppOption>
            <IconWhatsapp />
            <TextOption>Enviar por WhatsApp</TextOption>
          </WhatsAppOption>
          <SelectWhatsapp wpp={isSelected && type === 'whatsapp'}>
            <span />
          </SelectWhatsapp>
        </Section>

        <Section
          onClick={() => selectFunction('sms', typeContact)}
          className='sms-section'
        >
          <SMSOption>
            <IconSMS />
            <TextOption>Enviar por SMS</TextOption>
          </SMSOption>
          <SelectSMS sms={isSelected && type === 'sms'}>
            <span />
          </SelectSMS>
        </Section>
      </Options>
    </SMSWhatsapp>
  );
};

export default TelephoneCard;
